import Dexie from 'dexie';

const db = new Dexie('OLPrevenda');

// Tabelas com {Local} não existem na nuvem, e são normalmente usadas apenas para reexibição.

db.version(3).stores({
  usuario: `
  ++id,
  useidnuvem,
  usenome,
  usecpf,
  usesenha,
  usedataalteracao
  `,
  produto: `
  ++id,
  proidnuvem,
  prodescricao,
  provalor,
  proean,
  proidproduto,
  proreferencia,
  prodataalteracao,
  grudescricao
  `,
  cliente: `
  ++id,
  cliidnuvem,
  clinome,
  clicpf,
  cliidcliente
  `,
});

/* db.open().then((dexie) => {
  console.log('db | aberto: ', dexie);
}).catch((err) => {
  console.log('db | erro: ', err);
});
 */
// ORDERPRODUCAO?

export default db;
